import React from "react";
import { Box } from "@mui/material";

const ShoulderPage = () => {
  return (
    <Box
      sx={{
        padding: 10,
      }}
    >
      {"WIP: Shoulder"}
    </Box>
  );
};

export default ShoulderPage;
